export const roleDisplayNames: { [key: string]: string } = {
  Manager: 'Manager',
  Accounting: 'Accounting',
  Classroom: 'Classroom',
  Director: 'Director',
  Staff: 'Staff',
  FrontDesk: 'Front Desk',
  AuthorizedPickup: 'Authorized Pickup',
  Administrative: 'Administrative',
  Parents: 'Parents',
  Teachers: 'Teachers',
  SchoolScheduleEvent: 'School Schedule Event',
  EducationDirectorAdminAssistant: 'Ed. Director / Admin Assistant',
  UpperManagement: 'Upper Management',
  HRUser: 'HR User',
  FinanceUser: 'Finance User',
};

export const truncateText = (text: string, maxLength: number): string => {
  if (!text) return '';
  if (text?.length <= maxLength) {
    return text;
  }
  return text.substring(0, maxLength) + '...';
};

const getRoleDisplayName = (dbName: string): string => {
  return roleDisplayNames?.[dbName] || dbName;
};

export default getRoleDisplayName;
